<template>
    <div>
        <div>
            <div class="flex items-center mb-24">
                <div class="w-64 h-64">
                    <img :src="product.logo_square_url" :alt="`${product.name}-logo`">
                </div>
                <div class="flex flex-col ml-24">
                    <p class="text-heading-2 font-semibold mb">{{ product.name }}</p>
                    <div class="flex">
                        <p>{{ `${product.duration.period} ${product.duration.range}` }}</p>
                        <p class="ml-16">{{ `${price} ${product.vonq_price[0].currency}` }}</p>
                        <a :href="product.url" target="_blank" class="ml-16">{{ product.url }}</a>
                    </div>
                </div>
            </div>
            <p>{{ product.description }}</p>
        </div>
        <div class="border-t mt-24 mb-16"></div>
        <div>
            <div class="min-w-140 mr-24 my-16">
                <label class="text-body font-semibold">{{ $t('multi-posting.job-boards.processing_time') }}</label>
                <p>{{ product.name }}</p>
            </div>
            <div class="min-w-140 mr-24 my-16">
                <label class="text-body font-semibold">{{ $t('multi-posting.job-boards.locations') }}</label>
                <div class="flex flex-col">
                    <template v-if="product.locations && product.locations.length">
                        <p v-for="location in product.locations" class="mr-16">{{ location.name }}</p>
                    </template>
                    <template v-else>
                        <p>---</p>
                    </template>
                </div>
            </div>
            <div class="min-w-140 mr-24 my-16">
                <label class="text-body font-semibold">{{ $t('multi-posting.job-boards.industries') }}</label>
                <div class="flex">
                    <template v-if="product.industries && product.industries.length">
                        <p v-for="location in product.industries" class="mr-16">{{ location.name }}</p>
                    </template>
                    <template v-else>
                        <p>---</p>
                    </template>
                </div>
            </div>
            <div class="flex justify-end">
                <a v-if="product.vacancyCount" href="#" class="text-secondary mr-16">
                    {{ `${$t('multi-posting.job-boards.view_vacancies')} (${product.vacancyCount})` }}
                </a>
                <simple-button
                    display="secondary"
                    look="primary"
                    @click="addToCampaign"
                >
                    {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import SimpleButton from "../ui/SimpleButton.vue";

export default {
    name: 'JobBoardDetails',
    components: { SimpleButton },
    props: {
        product: { type: Object, required: true }
    },
    computed: {
        price() {
            return this.product.vonq_price[0].amount.toFixed(2);
        }
    },  
    methods: {
        addToCampaign() {
            this.$emit('add-to-campaign', this.product);
        }
    },
}
</script>